import { render, staticRenderFns } from "./MemberNew.vue?vue&type=template&id=3b354bc4&"
import script from "./MemberNew.vue?vue&type=script&lang=js&"
export * from "./MemberNew.vue?vue&type=script&lang=js&"
import style0 from "./MemberNew.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./MemberNew.vue?vue&type=style&index=1&lang=scss&module=s&"




function injectStyles (context) {
  
  this["s"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports